<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="群名称" clearable @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border >
          <yq-table-column label="头像" prop="avatar" width="60rem">
            <template v-slot="{row}">
              <image-show v-model="row.avatar" height=".8rem" width=".8rem"/>
            </template>
          </yq-table-column>
          <yq-table-column  label="企业微信外部群名称" prop="groupName" min-width="180rem" />
          <yq-table-column label="群主" prop="employeeName"/>
          <yq-table-column label="创建时间" prop="createdTime" min-width="180rem" />
          <yq-table-column label="群聊人数" prop="memberCount"/>
          <yq-table-column label="开启自动报价" prop="chatHistoryStatus" min-width="180rem" >
            <template v-slot="{row}">
              <el-tag v-if="row.autoReply === 1" type="primary">已开启</el-tag>
              <el-tag v-else type="info">未开启</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="potion" width="180rem" align="center">
            <template v-slot="{row}">
              <table-button-group>
                <table-button v-if="row.autoReply === 0" @click="changeStatus(row, 1)">开启自动报价</table-button>
                <table-button v-if="row.autoReply === 1" @click="changeStatus(row, 0)">关闭自动报价</table-button>
                <table-button @click="refreshMember(row)">更新群成员</table-button>
                <table-button @click="openGroupInfo(row)">群管理</table-button>
                <table-button @click="deleteGroup(row)" el-type="danger" message="此操作只会删除AI报价系统中的群聊，并不会删除企业微信里的群，如果要删除企业微信的群，请在企业微信进行操作。是否确认删除数据，删除数据后如果AI员工刷新群信息时将再次同步这个群">删除群</table-button>
              </table-button-group>

            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList" :default-load="false"/>
    </list-page>
    <el-dialog v-model="showDialog" dialog-width="3" :title="`${currentData.gropuName}成员管理`">
      <dialog-table>
        <yq-table :data="dialogList">
          <yq-table-column label="头像" prop="iconUrl" align="center">
            <template v-slot="{row}">
              <image-show v-model="row.iconUrl" height=".8rem" width=".8rem"/>
            </template>
          </yq-table-column>
          <yq-table-column label="成员名称" prop="xbotName" :show-overflow-tooltip="true"/>
          <yq-table-column label="成员昵称" prop="xbotNickName" :show-overflow-tooltip="true"/>
          <yq-table-column label="来源" prop="xbotMemberType">
            <template v-slot="{row}"><el-tag type="success" size="small" v-if="row.xbotMemberType===1">微信</el-tag><span v-else></span></template>
          </yq-table-column>
          <yq-table-column label="关联客户" prop="erpBtypeName"/>
          <yq-table-column label="客户联系人" prop="erpCustomerName"/>
          <yq-table-column label="操作" prop="option" align="center">
            <template v-slot="{row}">
              <table-button @click="toCreateRelation(row)">关联客户</table-button>
            </template>
          </yq-table-column>
        </yq-table>
      </dialog-table>
      <template #footer>
        <page-button @click="showDialog = false">取消</page-button>
      </template>
    </el-dialog>
    <el-dialog v-model="showCreateRelationDialog" title="关联客户" dialog-width="1">
      <form-items :columns="1" label-width="2.4rem">
        <form-item label="群聊成员">
          <el-input v-model="currentRelation.xbotName" disabled/>
        </form-item>
        <form-item label="ERP客户">
          <erp-customer-external-select v-model="currentRelation.erpCustomerId" placeholder="请选择客户" />
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showCreateRelationDialog = false">取消</page-button>
        <page-button @click="saveRelation" el-type="primary">保存</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import qywxXbotGroupApi from "@/api/dz-ai/qywxXbotGroupApi";
import TableButton from "@/components/h5/button/TableButton.vue";
import ImageShow from "@/components/h5/image/ImageShow.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import ErpCustomerExternalSelect from "@/components/h5/partner/ErpCustomerExternalSelect.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "ChatLogs",
  components: {
    ErpCustomerExternalSelect,
    YqTable,
    TableButtonGroup,DialogTable, FormItems, FormItem,
    ImageShow,
    TableButton,
    YqTableColumn, SearchCondition, FormPage, ListTable, ListPage,
  },
  data() {
    return {
      searchInfo: {
        hasMore: false,
        limit: 20,
      },
      dataList: [],
      showDialog: false, // 显示弹框，成员管理
      dialogList: [],
      currentData: {},
      showCreateRelationDialog: false, // 显示弹框，关联客户
      currentRelation: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.resetSearch();
  },
  methods: {
    queryList() {
      qywxXbotGroupApi.queryList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      })
    },
    resetSearch() {
      this.searchInfo.cursor = "";
      this.dataList = [];
      this.queryList();
    },
    changeStatus(data, status) {
      qywxXbotGroupApi.setReply({id: data.id, autoReply: status}).then(() => {
        this.queryList();
      })
    },
    deleteGroup(data) {
      qywxXbotGroupApi.deleteGroup({id: data.id}).then(() => {
        this.queryList();
      })
    },
    // 打开群管理页面
    openGroupInfo(data) {
      this.currentData = data;
      // 获取群客户列表
      qywxXbotGroupApi.queryGroupMembers({id: data.id}).then(list => {
        this.showDialog = true;
        this.currentData = data;
        this.dialogList = list;
      });
    },
    refreshMember(data) {
      qywxXbotGroupApi.refreshGroup(data.id).then(() => this.$message.success("群成员信息已更新"))
    },
    toCreateRelation(data) {
      this.currentRelation.xbotId = data.xbotMemberId;
      this.currentRelation.xbotName = data.xbotName;
      this.currentRelation.erpCustomerId = data.erpCustomerId || "";
      this.showCreateRelationDialog = true;
    },
    // 保存ERP客户关联关系
    saveRelation() {

    }
  }
};
</script>

<style lang="scss" scoped>
</style>